export default __webpack_public_path__ + "static/media/play_circle.9ad98eea.svg";